export const APP_TEXT_EN = {
  home: {
    pageTitle: 'Home',
    languageTitle: 'Language',
    languageDialogTitle: 'Select the language you want to switch to:',
    langSpanish: 'Español',
    langEnglish: 'English',
    changeLanguageButton: 'Cambiar idioma',
    editProfile: 'Edit profile',
    myProfile: 'My profile',
    changePassword: 'Change password',
    welcomeToTitle: 'Welcome to',
    scanEnclosureButton: 'Scan enclosure',
    searchFiltersTitle: 'Search filters',
    selectedEnclosureLabel: 'Selected enclosure',
    enclosureLabel: 'Enclosure',
    selectEnclosureHint: 'Select an enclosure',
    allEnclosuresOption: 'All enclosures',
    noPurchasedTicketsText: "Oops, you don't have any purchased tickets yet.",
    noPurchasedTicketsHelpText: 'Select your preferred enclosure and purchase your parking access in advance.',
    buyTicketsButton: 'Buy Tickets',
    prepaidTitle: 'Prepaid',
    ticketsTitle: 'Tickets',
    balanceLabel: 'Balance',
    reloadButton: 'Reload',
    dateLabel: 'Date',
    qrTitle: 'QR',
    closeButton: 'Close',
    loadBalanceTitle: 'Load balance',
    emailLabel: 'Email',
    balanceToLoadLabel: 'Amount to load',
    cancelButton: 'Cancel',
    goToPaymentButton: 'Go to payment',
    acceptButton: 'Accept',
    errorTitle: 'Error',
    genericErrorMessage: 'Sorry, an error occurred.',
    qrErrorMessage: 'Sorry, an error occurred while retrieving the QR code.',
    balanceRequiredMessage: 'You must enter the amount.',
    userAvatarAlt: 'User avatar',
    homeHeroAlt: 'Home hero view',
    homeHeroMobileAlt: 'Home hero view in vertical format',
    qrIconAlt: 'QR code',
    modalQrImageAlt: 'QR code image',
    logoAlt: 'Parkit logo',
  },
  sidebar: {
    helloPrefix: 'Hi',
    editProfile: 'Edit profile',
    myProfile: 'My profile',
    changePassword: 'Change password',
    closeSession: 'Sign out',
    notificationAction: 'Action',
    notificationAnotherAction: 'Another action',
    notificationSomethingElse: 'Something else here',
    home: 'Home',
    qrSection: 'QR',
    qrScanner: 'QR Scanner',
    eventsSection: 'Events',
    eventsQuery: 'Event lookup',
    buyTicketsSection: 'Buy tickets',
    selectEnclosure: 'Select your venue',
    myTickets: 'My tickets',
    vehicles: 'Vehicles',
    salesSection: 'Sales',
    eventReports: 'Event reports',
    userReports: 'User reports',
    vipZoneReports: 'VIP zone reports',
    prepaidUserReports: 'Prepaid user reports',
    careAccountReport: 'CARE account status report',
    vipStatusReport: 'VIP status report',
    reportByMonth: 'Monthly report',
    reportClosingMonth: 'Month-end closing report',
    adminSection: 'Administration',
    users: 'Users',
    zones: 'Zones',
    enclosures: 'Enclosures',
    localities: 'Localities',
    parkingZone: 'Parking zone',
    eventTypes: 'Event types',
    discountCode: 'Discount code',
    disclaimers: 'Disclaimers',
    qrGeneration: 'QR generation',
    qrSubscribers: 'Subscriber QR',
    parkingPensConfig: 'Barrier gate settings',
    prepaidSection: 'Prepaid',
    prepaidTypes: 'Prepaid types',
    createNewProfile: 'Create new profile',
    prepaidUsersAdminSection: 'Prepaid user administration',
    registerQrs: 'Register QRs',
    changeQrType: 'Change QR type',
    subscribersSection: 'Subscribers',
    subscriberList: 'Subscriber list',
    walletSection: 'View wallet',
    wallet: 'Wallet',
    consultReloadQr: 'View/Reload QR',
    movementHistory: 'History',
    partners: 'Parkit partners',
    scanEnclosure: 'Scan enclosure',
    languageTitle: 'Language',
    langSpanish: 'Español',
    langEnglish: 'English',
    logoutButton: 'Log Out',
  },
  footer: {
    rightsReserved: 'All rights reserved',
    termsTitle: 'TERMS AND CONDITIONS',
    closeButton: 'Close',
  },
  header: {
    home: 'Home',
    selectEnclosure: 'Select the enclosure',
    buyParkingSpot: 'BUY PARKING SPOT',
    prepaid: 'Prepaid',
    logoAlt: 'Logo',
    helloPrefix: 'Hello',
    userFallback: 'user',
    openProfileMenu: 'Open profile menu',
    myProfile: 'My profile',
    changePassword: 'Change password',
    closeSession: 'Log out',
  },
  loaders: {
    loadingGeneric: 'Loading',
    loadingSrOnly: 'Loading...',
    loadingResources: 'Loading resources',
    loadingReportTitle: 'Loading Report',
    loadingReport: 'Loading report...',
    loadingData: 'Loading data...',
    loadingZonesTitle: 'Loading zones',
    loadingZones: 'Loading zones...',
    loadingSchedules: 'Loading schedules...',
    loadingEventsTitle: 'Loading Events',
    loadingEventsPreloader: 'Loading events',
    loadingEvents: 'Loading events...',
    loadingMessages: 'Loading messages...',
    loadingTicketInfo: 'Loading ticket information...',
    loadingAvailableParkingZone: 'Loading your available parking area',
    loadingPartners: 'Loading partners...',
    loadingUserTitle: 'Loading User',
    loadingUsersTitle: 'Loading Users',
    loadingTicketsTitle: 'Loading Tickets',
    loadingSubscribersTitle: 'Loading Subscribers',
    loadingParkingZones: 'Loading parking zones...',
    loadingInfo: 'Loading information...',
    loadingAvailableZones: 'Loading available zones...',
    loadingMap: 'Loading map...',
  },
  locality: {
    pageTitle: 'Select your city',
    headerTitle: 'Choose your city',
    searchPlaceholder: 'Search city or enclosure...',
    clearSearchButton: 'Clear search',
    resultFoundSingular: 'result found',
    resultsFoundPlural: 'results found',
    loadingSrOnly: 'Loading...',
    loadingCities: 'Searching cities...',
    viewEnclosuresButton: 'View Enclosures',
    citiesSection: 'Cities',
    enclosuresSection: 'Enclosures',
    viewEventsButton: 'View Events',
    viewDetailsButton: 'View Details',
    viewWalletButton: 'View Wallet',
    buyTicketsButton: 'Buy Tickets',
    noResultsTitle: 'No results for',
    noResultsMessage: 'Try another city or enclosure name',
    emptyLocalitiesTitle: 'No available localities found',
    emptyLocalitiesMessage: 'Try reloading the page later',
    allLocalitiesOption: 'All localities',
    allLocalitiesSelectedCityName: 'Mexico',
  },
  enclosureByLocality: {
    pageTitle: 'Enclosures by locality',
    cityImageAlt: 'City',
    heroTitlePrefix: 'Explore',
    heroSubtitle: 'Discover the best events and places in your city',
    searchPlaceholder: 'Search enclosure...',
    clearSearchButton: 'Clear search',
    resultFoundSingular: 'enclosure found',
    resultsFoundPlural: 'enclosures found',
    loadingSrOnly: 'Loading...',
    viewEventsButton: 'View Events',
    viewDetailsButton: 'View Details',
    viewWalletButton: 'View Wallet',
    buyTicketsButton: 'Buy Tickets',
    noResultsTitle: 'No results for',
    noEnclosuresInCityMessage: 'No enclosures were found in {city}.',
    backToLocalitiesButton: 'Back to Localities',
    allLocalitiesSelectedCityName: 'Mexico',
    selectedCityFallback: 'this city',
  },
  salesUsers: {
    pageTitle: 'Ticket purchase',
    cartTitle: 'My cart',
    emptyCartTitle: 'Your cart is empty',
    emptyCartMessage: 'Explore the events and add tickets to get started.',
    viewEventsButton: 'View Events',
    roundTripLabel: 'Your purchase includes your round-trip ticket',
    ticketsIncludedLabel: 'tickets included',
    removeButtonLabel: 'Remove',
    subtotalLabel: 'Subtotal',
    serviceChargeLabel: 'Service charge',
    totalLabel: 'Total',
    addMoreButton: 'Add more',
    payNowButton: 'Pay now',
    cancelButton: 'Cancel',
    logoAlt: 'Parkit logo',
    selectModeTitle: 'Select one of the following options.',
    eventsModeButton: 'Events',
    prepaidModeButton: 'Prepaid',
    subscribersModeButton: 'Subscribers',
    allInOneEyebrow: 'Buy tickets',
    allInOneTitle: 'Choose how you want to get to the event',
    allInOneSubtitle: 'Select an option to continue with your purchase.',
    allInOneParkingButton: 'Parking',
    allInOneParkingDescription: 'Reserve your parking spot for the event.',
    allInOneTransportButton: 'Transport',
    allInOneTransportDescription: 'Buy your ride and travel without worrying about driving.',
    allInOneBundleButton: 'Transport and Parking',
    allInOneBundleDescription: 'Combine both services into one experience.',
    carTypeLabel: 'Vehicle type:',
    selectedCarLabel: 'Selected vehicle:',
    selectCarTypePlaceholder: 'Select your vehicle type',
    noEventsAlert: 'Sorry, we do not have events for this enclosure yet.',
    eventLabel: 'Event:',
    swipeForMore: 'Swipe to see more',
    selectedEventLabel: 'Selected event:',
    selectEventPlaceholder: 'Select an event',
    loadingSrOnly: 'Loading...',
    loadingParking: 'Loading parking areas...',
    availableParkingLabel: 'Available parking areas',
    busSchedulesLabel: 'Bus schedules',
    zoneLabel: 'Zone',
    busLabel: 'Bus',
    scheduleLabel: 'Schedule',
    selectZonePlaceholder: 'Select a zone',
    loadingAddress: 'Loading address...',
    addressLabel: 'Address',
    referenceLabel: 'Reference',
    passengersLabel: 'Passengers',
    ticketsLabel: 'Tickets',
    oneTicketLabel: '1 ticket',
    singleSelectionLabel: 'Single selection',
    numberOfTicketsLabel: 'Number of tickets',
    numberOfPassengersLabel: 'Number of passengers',
    tripTypeLabel: 'Trip type',
    roundTripTripOption: 'Round trip (outbound and return)',
    oneWayTripIdaOption: 'One way (outbound only)',
    oneWayTripVueltaOption: 'One way (return only)',
    bundleTripNote: 'Parking included: round-trip (outbound and return) is required.',
    maxPerCartWarning: 'You can buy up to 10 spots per shopping cart',
    eventDetailsTitle: 'Event details',
    eventSummaryLabel: 'Event',
    dateSummaryLabel: 'Date',
    priceSummaryLabel: 'Price',
    availableSummaryLabel: 'Available',
    importantInfoTitle: 'Important information',
    acceptTermsPrefix: 'I have read and accept the',
    acceptTermsShort: 'Accept the',
    termsAndConditions: 'Terms and Conditions',
    dataTitle: 'DETAILS',
    availablePlacesLabel: 'Available spots',
    clearButton: 'Clear',
    getFreeTicketButton: 'Get free ticket',
    getTicketsButton: 'Get tickets',
    addToCartButton: 'Add to cart',
    prepaidTitle: 'Prepaid',
    prepaidEyebrow: 'Digital Pass',
    prepaidDescription: 'Get your prepaid QR code for fast, secure access to the venue parking.',
    prepaidBenefitQrTitle: 'Unique QR Code',
    prepaidBenefitQrDesc: 'Direct access to venue barriers without paper tickets.',
    prepaidBenefitBalanceTitle: 'Rechargeable Balance',
    prepaidBenefitBalanceDesc: 'Top up your digital wallet whenever needed.',
    prepaidBenefitFastTitle: 'No Lines or Waiting',
    prepaidBenefitFastDesc: 'Automated entry and exit during your visit.',
    prepaidReminder: 'Remember to read the terms and conditions before generating your ticket',
    generatePrepaidQrButton: 'Generate Prepaid QR',
    subscribersTitle: 'Subscribers',
    selectSubscriberLabel: 'Select the subscription you want to buy:',
    selectSubscriberPlaceholder: 'Select a subscription',
    loadingDetails: 'Loading details...',
    subscriberLabel: 'Subscription',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date',
    viewIncludedEventsButton: 'View all included events',
    buySubscriberButton: 'Buy Subscription',
    purposeText: 'Our purpose is to improve the experience at in-person events.',
    mapAlt: 'Enclosure map or logo',
    loadingAvailableParkingZone: 'Loading available parking area',
    locateMeTooltip: 'Show my location',
    loadingLocation: 'Loading location...',
    mapLoadError: 'The map could not be loaded.',
    changeEnclosureButton: 'Change venue',
    alertModalTitle: 'Notice',
    acceptButton: 'Accept',
    confirmationBadge: 'Confirmation',
    processReadyTag: 'Process ready to continue',
    reviewPurchaseTag: 'Review and confirm your purchase',
    continueButton: 'Continue',
    prepaidSuccessTitle: 'Hello {user}!',
    prepaidSuccessMessage: 'Prepaid ticket purchased successfully!',
    includedEventsModalTitle: 'Events included in this subscription',
    closeButton: 'Close',
    carTypeLabels: {
      compact: 'Compact',
      sedan: 'Sedan / Coupe',
      suv: 'SUV',
      pickup: 'Pickup truck',
      hybrid: 'Hybrid / Electric',
      bus: 'Bus',
      passengers: 'Passengers',
    },
    ticketTypeLabels: {
      departure: 'Outbound',
      return: 'Return',
    },
    busScheduleFormat: 'Outbound: {departure} → Return: {return}',
    locationTimeoutError: 'Timed out while getting your location.',
    locationUnavailableError:
      'Location is currently unavailable. The device reported a problem.',
    locationPermissionError: 'We do not have permission to access your location.',
    locationGenericError: 'An error occurred while getting your location: {error}',
    availableParkingFallback: 'Available parking area',
    myLocationPopup: 'Your location',
    removeRoundTripMessage:
      'Round-trip tickets{event} will be removed from your cart. You can add them again if there is still availability.',
    removeSingleMessage:
      'Do you want to remove this ticket{event} from your cart? You can add it again if there is still availability.',
    removeTicketsTitle: 'Remove tickets',
    removeTicketTitle: 'Remove ticket',
    keepButton: 'Keep',
    deleteButton: 'Remove',
    cartNotFoundError: 'The active cart could not be found for removal.',
    cartUserNotFoundError: 'The cart user could not be identified.',
    cartTicketsNotFoundError: 'The tickets to remove could not be identified.',
    deleteReturnTicketError: 'The return ticket could not be removed from the cart.',
    deleteDepartureTicketError: 'The outbound ticket could not be removed from the cart.',
    loadCartUserMissingError: 'Your cart could not be loaded because the user could not be identified.',
    loadCartError: 'The cart could not be loaded.',
    insufficientZonePlacesError:
      'Sorry, it is not possible to purchase {count} spot(s) in this zone.',
    successTitle: 'Success',
    ticketsGeneratedSuccess: 'Tickets generated successfully',
    ticketGeneratedSuccess: 'Ticket generated successfully',
    unknownError: 'Unknown error',
    errorTitle: 'Error',
    noSchedulePlacesError: 'Sorry, there are no available spots for this schedule.',
    insufficientZonePurchaseError:
      'Sorry, it is not possible to purchase {count} spot(s) in this zone. Please review other options or reduce the quantity.',
    soldOutZoneError:
      'Sorry, it is not possible to purchase the selected ticket quantity in this zone because it is sold out. Please review other zones.',
    zoneUnavailableError:
      'We are sorry for the inconvenience; at the moment it is not possible to buy tickets in this zone. Please try again later.',
    cartCapacityError:
      'Sorry, it is not possible to purchase {count} spot(s) because the remaining capacity in your cart is {available}.',
    cartAddedMessage:
      'From this moment on, you will have 15 minutes to complete your transaction; otherwise, the tickets will be released.',
    cartAddedTitle: 'Added to cart!',
    deleteTicketError: 'The ticket could not be removed from the cart.',
    emptyCartError: 'The cart could not be emptied.',
    termsRequiredError: 'You must accept the terms and conditions to continue',
    termsModalTitle: 'Terms and conditions',
    alertTitle: 'Notice',
    mustAcceptTermsToBuy: 'You must accept the terms and conditions to make the purchase',
    alertCancelButton: 'Cancel',
    subscribersLoadError: 'User subscriptions could not be loaded',
    subscriberDetailsLoadError: 'Subscription details could not be loaded',
    warningTitle: 'Warning',
    selectSubscriberWarning: 'Please select a subscription',
    selectedSubscriberDetailsNotFound:
      'The selected subscription details could not be found',
    selectedSubscriberNotFound: 'The selected subscription could not be found',
    subscriberAssignedSuccess: 'Subscription assigned to the user successfully',
    assignSubscriberError: 'Error assigning the subscription',
    unexpectedServerResponse: 'Unexpected server response',
    unknownAssignSubscriberError: 'Unknown error while assigning the subscription',
    infoTitle: 'Information',
    noEventsForSubscriber: 'There are no events available for this subscription',
  },
  buyingTickets: {
    // Cart panel
    cartTitle: 'My Cart',
    cartEmpty: 'Your cart is empty',
    cartEmptyHint: 'Add tickets to get started!',
    roundTripLabel: 'Your purchase includes your round-trip ticket',
    ticketsIncludedLabel: 'tickets included',
    removeButton: 'Remove',
    subtotalLabel: 'Subtotal',
    serviceChargeLabel: 'Service fee',
    totalLabel: 'Total',
    addMoreButton: 'Add more',
    payNowButton: 'Pay Now',
    // Confirm modal
    confirmationBadge: 'Confirmation',
    requestProcessedTag: 'Your request was processed',
    continueNextStepTag: 'Continue to the next step',
    continueButton: 'Continue',
    ticketAcquiredTitle: 'Ticket acquired!',
    eventTicketGeneratedSuccess: 'Your event ticket has been successfully generated.',
    cartAddedTitle: 'Added to cart!',
    cartAddedMessage: 'From this moment, you will have 15 minutes to complete your transaction, otherwise the tickets will be released.',
    // Incomplete purchase alert
    dearUserPrefix: 'Dear',
    thankYouForPurchase: 'Thank you for your purchase!',
    incompletePurchaseNote: 'Don\'t forget to purchase the missing tickets (parking or bus) to reach the venue.',
    eventLabel: 'Event:',
    missingBusTicket: 'Missing bus ticket',
    personInCar: 'person in the car',
    personsInCar: 'persons in the car',
    busTicketsLabel: 'bus tickets',
    missingParkingTicket: 'Missing parking ticket',
    withBusLabel: 'with bus',
    withParkingLabel: 'with parking',
    recommendAcquirePrefix: 'We recommend acquiring',
    busTicketSingularLabel: 'bus ticket',
    busTicketPluralLabel: 'bus tickets',
    parkingTicketSingularFor: 'parking ticket for',
    parkingTicketPluralFor: 'parking tickets for',
    buyBusButton: 'Buy bus',
    buyParkingButton: 'Buy parking',
    skipButton: 'Skip',
    missingEventTicket: 'Missing event ticket',
    missingBothTickets: 'Missing event ticket and bus ticket',
    // Error alert
    sorryLabel: 'We\'re sorry',
    closeButton: 'Close',
    genericError: 'An error occurred.',
    ticketAcquireError: 'An error occurred while acquiring the ticket.',
    ticketsCreationError: 'Tickets could not be created. Please try again.',
    // Buy event mode (parking ticket)
    buyParkingBadge: 'Buy parking ticket',
    selectTicketTitle: 'Select your ticket',
    carEventZoneSubtitle: 'Choose your car type, event, and parking zone',
    carTypeLabel: 'Car type',
    selectedCarLabel: 'Selected car',
    noEventsAvailable: 'No events available for this venue.',
    selectedEventLabel: 'Selected event',
    enclosureLocationLabel: 'Enclosure location',
    parkingBoardLabel: 'Parking zone to check in',
    passengersInCarQuestion: 'How many passengers in the car to park?',
    addressLabel: 'Address',
    referenceLabel: 'Reference',
    priceLabel: 'Price',
    freeLabel: 'Free',
    availableLabel: 'Available',
    acceptTermsPrefix: 'I have read and accept the',
    termsAndConditions: 'Terms and Conditions',
    processingLabel: 'Processing...',
    noAvailabilityLabel: 'No availability',
    acquireTicketButton: 'Get Ticket',
    addToCartButton: 'Add to cart',
    cancelButton: 'Cancel',
    // Bus / multiple area mode
    buyBusBadge: 'Buy bus ticket',
    yourEventIs: 'Your event is:',
    howManyPeopleQuestion: 'How many people are going?',
    personSingular: 'person',
    personPlural: 'persons',
    yourParkingSpotIs: 'Your parking spot is:',
    completePurchaseTitle: 'Complete your purchase!',
    busTicketIncludesPrefix: 'Your event ticket includes',
    needToAcquirePrefix: 'You need to purchase',
    boardingTransportSuffix: 'so everyone can board the transport.',
    withoutBusTicketPrefix: 'Without the bus ticket',
    cannotBoardLabel: 'you will not be able to board',
    transportServiceLabel: 'the transport service',
    selectScheduleBelow: 'Select your schedule below and confirm your purchase',
    scheduleRegisteredTitle: 'Schedule registered!',
    scheduleSelectedPrefix: 'You have selected schedule',
    forPrefix: 'for',
    busTicketRequestedSuffix: 'Your bus ticket has been requested.',
    viewMyTicketsButton: 'View my tickets',
    selectBusScheduleLabel: 'Select your bus schedule',
    returnLabel: 'Return:',
    howManyBusTicketsQuestion: 'How many bus tickets?',
    importantInfoTitle: 'Important information',
    selectedScheduleLabel: 'Selected schedule',
    buyBusTicketAction: 'Buy bus ticket',
    selectScheduleFirstLabel: 'Select a schedule first',
    tripTypeLabel: 'Trip type',
    roundTripTripOption: 'Round trip (outbound and return)',
    oneWayTripIdaOption: 'One way (outbound only)',
    oneWayTripVueltaOption: 'One way (return only)',
    // Empty state
    noPendingTicketsTitle: 'No pending tickets',
    noIncompleteText1: 'You have no incomplete purchases at this time.',
    noIncompleteText2: 'Explore available events and get your tickets.',
    chooseCityStep: 'Choose your city',
    selectEnclosureStep: 'Select venue',
    buyTicketStep: 'Buy your ticket',
    exploreEventsButton: 'Explore events',
    // Cart removal dialog
    removeTicketsTitle: 'Remove tickets',
    removeTicketTitle: 'Remove ticket',
    keepButton: 'Keep',
    deleteButton: 'Remove',
    removeRoundTripMessage: 'The round-trip tickets{event} will be removed from your cart. You can add them again if availability remains.',
    removeSingleMessage: 'Do you want to remove this ticket{event} from your cart? You can add it again if availability remains.',
    // Cart errors
    cartNotFoundError: 'Active cart not found for removal.',
    cartUserNotFoundError: 'Could not identify the cart user.',
    cartTicketsNotFoundError: 'Could not identify the tickets to remove.',
    deleteReturnTicketError: 'Could not remove the return ticket from the cart.',
    deleteDepartureTicketError: 'Could not remove the departure ticket from the cart.',
    loadCartUserMissingError: 'Could not load your cart because the user was not identified.',
    emptyCartError: 'Could not empty the cart.',
    deleteTicketError: 'Could not remove the ticket from the cart.',
    singleTicketToDeleteError: 'Could not identify the ticket to remove.',
  },
  login: {
    pageTitle: 'Sign in',
    loginTitle: 'Sign in',
    welcomeSubtitle: 'Welcome',
    preloaderMessages: [
      'Preparing your space...',
      'Loading your dashboard...',
      'Syncing access...',
      'Verifying permissions...',
      'Almost ready!',
    ],
    brandHeadlineMain: 'Your parking,',
    brandHeadlineAccent: 'smarter.',
    brandDesc:
      'Secure your spot with advance payment, avoid lines and delays. From your phone, reserve your space and enjoy your event worry-free.',
    firstStatNumber: 'QR',
    firstStatLabel: 'Fast access',
    secondStatNumber: 'Fast',
    secondStatLabel: 'Entry',
    emailOption: 'Email',
    emailOptionDesc: 'Sign in with your email and password',
    whatsappOption: 'WhatsApp',
    whatsappOptionDesc: 'Verification code via phone',
    otherOptions: 'other options',
    recoverPassword: 'Forgot your password',
    createAccount: 'Create account',
    partnerAccessTitle: 'Partner access',
    partnerAccessDesc: 'Sign in or join as a Parkit partner',
    emailFormTitle: 'Welcome',
    emailFormSubtitle: 'Sign in with your email or username',
    emailLabel: 'Email / Username',
    emailPlaceholder: 'youremail@example.com',
    emailRequiredError:
      'This field is required. Please enter your email or username.',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    passwordRequiredError:
      'This field is required. Please enter your password.',
    enterBtn: 'Sign in',
    backBtn: 'Go back',
    whatsappFormTitle: 'Sign in with WhatsApp',
    whatsappFormSubtitle: 'You will receive a code on your phone',
    phoneLabel: 'Phone number',
    phonePlaceholder: '10 digits',
    phoneRequiredError: 'Please enter a valid phone number.',
    phonePatternError: 'The phone number must be 10 digits long.',
    sendCodeBtn: 'Send code',
    verifyTitle: 'Verification',
    verifySubtitle: 'Enter the code sent to your WhatsApp',
    verifyCodeRequired: 'You must enter the complete code.',
    verifyBtn: 'Verify code',
    langDialogTitle: 'Language',
    langSpanish: 'Español',
    langEnglish: 'English',
    changeLang: 'Cambiar idioma',
    errorDialogTitle: 'Attention',
    modalConfirmBtn: 'Understood',
    credentialFallbackError: 'Invalid credentials',
    registerInviteError:
      'Sorry, this feature is only for users already registered on our platform. We invite you to sign up.',
    createAccountPrompt: 'Would you like to create your account?',
    modalAcceptBtn: 'Accept',
    modalCloseBtn: 'Close',
    modalCancelBtn: 'Cancel',
    channelSelectionTitle: 'Where would you like to send the code?',
    channelSelectionMessage:
      'We detected this email associated with your account: {email}. Would you like to receive your login code by email or WhatsApp?',
    confirmEmailTitle: 'Account Confirmation',
    confirmEmailMessage: 'Your number is linked to the following email account:',
    confirmEmailQuestion: 'Would you like to send the code to your email or WhatsApp?',
    confirmEmailBtnEmail: 'Email',
    confirmEmailBtnWhatsapp: 'WhatsApp',
    verifyEmailSubtitle: 'Enter the code sent to your email',
    retryError: 'Error, please try again.',
    codeRequiredError: 'Please enter the full code.',
    invalidCodeError: 'The code entered is not valid.',
    userIdNotFoundError:
      'Error: user ID not found. Please request a new code.',
    codeMismatchError:
      'The code entered is incorrect. Please verify the code.',
    generalError: 'An error occurred. Please try again.',
    unknownError: 'Unknown error. Please try again.',
    codeVerificationError:
      'Please verify the entered code number. It does not match the record.',
    invalidCredentialsError:
      'The username and/or password are incorrect.',
    inactiveUserError: 'Inactive user',
  },
  partnerLogin: {
    pageTitle: 'Partner access',
    brandBadge: 'Partner Portal',
    brandHeadlineMain: 'Welcome',
    brandHeadlineAccent: 'back, partner.',
    brandDesc:
      'Access your dashboard to manage your parking operations, monitor revenue, and control access in real time.',
    featureOne: 'Real-time reports',
    featureTwo: 'QR access control',
    featureThree: 'Zone and pricing management',
    backToHome: 'Back to home',
    formTitle: 'Sign in',
    formSubtitle: 'Sign in with your email or username',
    emailLabel: 'Email / Username',
    emailPlaceholder: 'youremail@example.com',
    emailRequiredError: 'This field is required.',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    passwordRequiredError: 'This field is required.',
    submitButton: 'Enter dashboard',
    noAccountText: "Don't have an account yet?",
    registerButton: 'Register as partner',
    loginErrorFallback: 'An error occurred while signing in.',
    invalidCredentialsError: 'Incorrect credentials.',
    inactiveUserError: 'Inactive user',
  },
  partnerLanding: {
    pageTitle: 'Parkit partner program',
    languageTitle: 'Language',
    langSpanish: 'Español',
    langEnglish: 'English',
    loginButton: 'Sign in',
    heroBadge: 'Parkit partner program',
    heroTitleMain: 'Turn your space into a',
    heroTitleAccent: 'smart business',
    heroSubtitle:
      'Manage your parking operation, sell digital tickets, and control every access point with QR technology. Fast, secure, and hassle-free.',
    heroPrimaryButton: 'I want to become a partner',
    heroSecondaryButton: 'Learn more',
    slides: [
      {
        icon: 'fa-qrcode',
        title: 'QR access',
        desc: 'Each ticket generates a unique QR. Your staff scans it in seconds to validate entry.',
      },
      {
        icon: 'fa-chart-line',
        title: 'Real-time revenue',
        desc: 'Review sales, occupancy, and daily reports from any device.',
      },
      {
        icon: 'fa-tags',
        title: 'Zones and pricing',
        desc: 'Set up VIP areas, hourly pricing, and discount codes in minutes.',
      },
      {
        icon: 'fa-shield-alt',
        title: 'Full security',
        desc: 'Encrypted single-use QRs. No duplicates, no fraud, no worries.',
      },
      {
        icon: 'fa-mobile-alt',
        title: 'No extra hardware',
        desc: 'You only need a phone to scan. No costly terminals or installations.',
      },
    ],
    screenScanLabel: 'Scan access',
    screenSpacesLabel: 'Spaces',
    screenTodayLabel: 'Today',
    screenOccupiedLabel: 'Occupied',
    heroImageAlt: 'Parkit parking lot',
    heroImageBadge: 'Your space, powered up',
    statsActivePartners: 'Active partners',
    statsTicketsSold: 'Tickets sold',
    statsDigital: 'Fully digital',
    statsAlwaysAvailable: 'Always available',
    stepsSectionLabel: 'Simple process',
    stepsSectionTitle: 'How does it work?',
    stepsSectionSubtitle:
      'In three steps, your parking operation is running with Parkit',
    stepsImageAlt: 'Car entering the parking lot with controlled access',
    stepOneTitle: 'Register your space',
    stepOneDesc:
      'Create your partner account, add your parking lot, and configure your zones and available capacity.',
    stepTwoTitle: 'Sell digital tickets',
    stepTwoDesc:
      'Your customers buy their spot from their phone. You decide pricing, schedules, and availability.',
    stepThreeTitle: 'Control with QR',
    stepThreeDesc:
      'When the customer arrives, they show their QR and your staff scans it. Verified access in seconds, with no paper or lines.',
    benefitsSectionLabel: 'Why choose us',
    benefitsSectionTitleMain: 'Everything you need,',
    benefitsSectionTitleAccent: 'all in one place',
    benefitsImageAlt: 'Person using a phone inside the parking lot',
    benefitsImageBadge: 'Mobile management in real time',
    benefitOneTitle: 'Real-time reports',
    benefitOneDesc:
      'Monitor revenue, occupancy, and accesses instantly from any device.',
    benefitTwoTitle: '100% from your phone',
    benefitTwoDesc:
      'Manage everything from the Parkit mobile app. No expensive hardware installations.',
    benefitThreeTitle: 'Secure access',
    benefitThreeDesc:
      'Each QR is unique, encrypted, and single-use. Impossible to duplicate or forge.',
    benefitFourTitle: 'Flexible zones and pricing',
    benefitFourDesc:
      'Create VIP zones, time-based pricing, discounts, and passes for frequent customers.',
    benefitFiveTitle: 'User management',
    benefitFiveDesc:
      'Manage your staff team and assign roles and access permissions.',
    benefitSixTitle: 'Dedicated support',
    benefitSixDesc:
      'Guidance from the initial setup and ongoing support for your operation.',
    ctaImageAlt: 'Aerial view of a parking lot operating with Parkit',
    ctaTitle: 'Ready to get started?',
    ctaSubtitle:
      'Join hundreds of parking operators already running with Parkit. Registration is fast and free.',
    ctaPrimaryButton: 'Create my account now',
    ctaLoginPrefix: 'Already have an account?',
    ctaLoginButton: 'Sign in',
  },
  partnerRegister: {
    pageTitle: 'Partner registration',
    brandHeadlineMain: 'Your space,',
    brandHeadlineAccent: 'your business.',
    brandDesc:
      'Register your parking operation with Parkit and start selling digital tickets with QR technology.',
    sideStepOneNumber: 'Step 1',
    sideStepOneLabel: 'Account details',
    sideStepTwoNumber: 'Step 2',
    sideStepTwoLabel: 'Your space',
    sideStepThreeNumber: 'Step 3',
    sideStepThreeLabel: 'Location',
    mobileStepPrefix: 'Step',
    mobileStepConnector: 'of',
    accountTitle: 'Account details',
    accountSubtitle: 'Create your Parkit access credentials',
    usernameLabel: 'Username',
    usernamePlaceholder: 'Your username',
    usernameMinLengthError: 'Minimum 3 characters',
    usernamePatternError: 'Use only letters A to Z and numbers, without spaces or symbols.',
    emailLabel: 'Email address',
    emailPlaceholder: 'youremail@example.com',
    emailInvalidError: 'Invalid email',
    phoneLabel: 'Phone number',
    phonePlaceholder: '10 digits',
    phonePatternError: 'It must be 10 digits long',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Minimum 8 characters',
    passwordMinLengthError: 'Minimum 8 characters',
    confirmPasswordLabel: 'Confirm password',
    confirmPasswordPlaceholder: 'Repeat your password',
    passwordMismatchError: 'Passwords do not match',
    requiredFieldError: 'Required field',
    nextButton: 'Next',
    backButton: 'Go back',
    previousButton: 'Previous',
    spaceTitle: 'Your space',
    spaceSubtitle: 'Tell us about the space you want to register',
    businessNameLabel: 'Business name',
    optionalLabel: 'optional',
    businessNamePlaceholder: 'Ex. Central Parking',
    spaceTypeLabel: 'Physical space type',
    spaceTypeRequiredError: 'Select a space type',
    spaceTypes: [
      { value: 'terreno', label: 'Lot', icon: 'fa-map' },
      { value: 'estacionamiento', label: 'Parking lot', icon: 'fa-parking' },
      {
        value: 'plaza_comercial',
        label: 'Shopping plaza',
        icon: 'fa-store',
      },
    ],
    capacityLabel: 'Available space count',
    capacityPlaceholder: 'Ex. 50',
    capacityMinError: 'It must be at least 1',
    multiZoneLabel: 'Does it have more than one zone?',
    singleZoneButton: '1 Zone',
    multipleZonesButton: 'More than one zone',
    zonesLabel: 'Number of zones',
    zonesPlaceholder: 'Ex. 3',
    zonesMinError: 'Minimum 2 zones',
    locationTitle: 'Location',
    locationSubtitle: 'Where is your space located?',
    searchAddressLabel: 'Search address',
    searchAddressPlaceholder: 'Street, neighborhood, city...',
    addressRequiredError: 'Select a location on the map',
    locateMeTitle: 'Use my location',
    addressLabel: 'Address',
    addressPlaceholder: 'Edit or type an address...',
    relocateMapTitle: 'Reposition on map',
    addressHint:
      'Edit the address and press Enter (or the button) to reposition the pin',
    registerButton: 'Register my space',
    alreadyHaveAccountText: 'Already have an account?',
    loginButton: 'Sign in',
    successTitle: 'First step submitted!',
    successMessage:
      'The first part of your partner registration was received successfully. Sign in to continue your registration.',
    successButton: 'Go to sign in',
    errorTitle: 'An error occurred',
    closeButton: 'Close',
    geolocationUnsupportedError:
      'Your browser does not support geolocation.',
    geolocationPermissionError:
      'Your location could not be obtained. Check your permissions.',
    searchNoResultsError:
      'No results were found. Try another address.',
    searchLocationError: 'Error searching for the location.',
    registerFallbackError: 'An error occurred while registering. Please try again.',
    usernameTakenError: 'The username is already in use.',
    emailTakenError: 'The email is already registered.',
    phoneTakenError: 'The phone number is already registered.',
    emailAlreadyUserError:
      'This email is already registered as a Parkit user. To become a partner, you must use a different email than your user account.',
    usernameAlreadyUserError:
      'This username is already registered as a Parkit user. To become a partner, you must use a different username than your user account.',
    phoneAlreadyUserError:
      'This phone number is already registered as a Parkit user. To become a partner, you must use a different phone number than your user account.',
    usernameRequiredBackendError: 'Username is required.',
    emailRequiredBackendError: 'Email is required.',
    phoneRequiredBackendError: 'Phone number is required.',
    passwordRequiredBackendError: 'Password is required.',
    spaceTypeRequiredBackendError: 'Space type is required.',
    capacityRequiredBackendError: 'Capacity is required.',
    addressRequiredBackendError: 'Address is required.',
    latitudeRequiredBackendError: 'Latitude is required.',
    longitudeRequiredBackendError: 'Longitude is required.',
  },
  partnerDashboard: {
    pageTitle: 'Partner dashboard',
    languageDialogTitle: 'Select the language you want to switch to:',
    langSpanish: 'Español',
    langEnglish: 'English',
    changeLang: 'Cambiar idioma',
    logoutButton: 'Sign out',
    lightboxAlt: 'Expanded view',
    welcomeTitlePrefix: 'Welcome,',
    welcomeTitleSuffix: '!',
    welcomeSubtitle:
      'This is your Parkit partner dashboard. Here you can manage your account and your space.',
    refreshButton: 'Refresh',
    refreshLoading: 'Refreshing...',
    refreshErrorFallback: 'We could not refresh your information.',
    badges: {
      incomplete: 'Incomplete registration',
      review: 'Under review',
      active: 'Active account',
    },
    step2Banner: {
      title: 'Complete your registration - Step 2 of 2',
      description:
        'To activate your account, we need to verify that you are the owner or authorized representative of the space. It only takes a few minutes.',
      button: 'Continue verification',
    },
    reviewBanner: {
      title: 'Your documents are under review',
      description:
        'Our team is reviewing the information you submitted. We will notify you by email once your account is activated.',
    },
    progress: {
      title: 'Registration status',
      stepOne: {
        title: 'Step 1',
        label: 'Account registration',
        detail: 'Your account was created successfully.',
      },
      stepTwo: {
        title: 'Step 2',
        label: 'Property verification',
        detailPending: 'Pending - send your documents.',
        detailReview: 'Under review by our team.',
        detailApproved: 'Verification approved.',
      },
      stepThree: {
        title: 'Step 3',
        label: 'Active account',
        detailPending: 'Available once verification is completed.',
        detailDone: 'Your account is active!',
      },
    },
    accountCard: {
      title: 'Account details',
      username: 'Username',
      email: 'Email',
      phone: 'Phone',
      status: 'Status',
    },
    statusValues: {
      pendiente: 'Pending',
      activo: 'Active',
      rechazado: 'Rejected',
    },
    spaceCard: {
      title: 'Your space',
      name: 'Name',
      type: 'Type',
      capacity: 'Capacity',
      capacityUnit: 'spots',
      zones: 'Zones',
      address: 'Address',
      photos: 'Space photos',
      parkingPhoto: 'Parking lot',
      mapPhoto: 'Map',
    },
    verificationCard: {
      title: 'Identity verification',
      firstName: 'First name',
      lastName: 'Last name',
      idType: 'Identification',
      idNumber: 'Number',
      propertyDocType: 'Document',
      propertyDocReference: 'Reference',
      documents: 'Attached documents',
      idFront: 'ID front',
      idBack: 'ID back',
      propertyDoc: 'Property doc',
    },
    bottomCta: {
      text: 'Ready to continue? Step 2 only takes a few minutes.',
      button: 'Send my documents',
    },
    spaceTypeLabels: {
      terreno: 'Lot',
      estacionamiento: 'Parking lot',
      plaza_comercial: 'Shopping plaza',
    },
    idTypeLabels: {
      ine: 'INE / IFE',
      pasaporte: 'Passport',
      cedula: 'Professional license',
      otro: 'Other',
    },
    propertyDocTypeLabels: {
      escritura: 'Public deed',
      contrato_arrendamiento: 'Lease agreement',
      titulo_propiedad: 'Property title',
      otro: 'Other',
    },
  },
  changeProfile: {
    pageTitle: 'Edit profile',
    cardSubtitle: 'Update your contact information and password.',
    cancelButton: 'Cancel',
    emailLabel: 'Email:',
    emailPlaceholder: 'test@test.com',
    nameLabel: 'Name:',
    namePlaceholder: 'userTT',
    phoneLabel: 'Phone:',
    phonePlaceholder: '55 2557 8634',
    phoneLockedHint: 'Your phone number can\'t be edited because it was the method you used to create your account.',
    passwordLabel: 'Password:',
    passwordPlaceholder: '123456',
    confirmPasswordLabel: 'Repeat password:',
    confirmPasswordPlaceholder: '123456',
    submitButton: 'Update',
    logoAlt: 'Parkit logo',
    successModalTitle: 'Confirmation',
    successModalMessage: 'Your profile was updated successfully!',
    successModalButton: 'Continue',
    warningModalTitle: 'Oops!!!!!',
    warningModalButton: 'Continue',
    passwordMismatchError: 'Passwords do not match',
    passwordFormatError:
      'Password must include at least one uppercase letter, one lowercase letter, one special character, and one number',
    emailRequiredError: 'Please enter a valid email.',
    emailInvalidError: 'Enter a valid email address.',
    nameRequiredError: 'Username is required.',
    nameMinLengthError: 'Minimum 5 characters.',
    phoneRequiredError: 'Phone number is required.',
  },
  changePass: {
    pageTitle: 'Change password',
    cancelButton: 'Cancel',
    emailLabel: 'Email:',
    emailPlaceholder: 'test@test.com',
    currentPasswordLabel: 'Current password:',
    currentPasswordPlaceholder: '123456',
    newPasswordLabel: 'New password:',
    newPasswordPlaceholder: '123456',
    confirmPasswordLabel: 'Repeat password:',
    confirmPasswordPlaceholder: '123456',
    submitButton: 'Change',
    logoAlt: 'Parkit logo',
    successModalTitle: 'Confirmation',
    successModalMessage: 'Your password was changed successfully!',
    successModalButton: 'Continue',
    warningModalTitle: 'Oops!!!!!',
    warningModalButton: 'Continue',
    passwordMismatchError: 'Passwords do not match',
    passwordFormatError:
      'Password must include at least one uppercase letter, one lowercase letter, one special character, and one number',
  },
  register: {
    pageTitle: 'Create account',
    cardTitle: 'Create account',
    cardSubtitle: 'Fill in the details to register',
    usernameLabel: 'Username',
    usernamePlaceholder: 'Your username',
    emailLabel: 'Email address',
    emailPlaceholder: 'youremail@example.com',
    phoneLabel: 'Phone number',
    phonePlaceholder: '10 digits',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Minimum 8 characters',
    confirmPasswordLabel: 'Confirm password',
    confirmPasswordPlaceholder: 'Repeat your password',
    submitBtn: 'Create account',
    backBtn: 'Back to sign in',
    helpLink: 'Have questions? Click here',
    inputRequired: 'This field is required',
    validNameRequired: 'Minimum 5 characters',
    validEmailRequired: 'Enter a valid email',
    phoneMinLength: 'Phone number must be 10 digits',
    passwordMinLength: 'Minimum 6 characters',
    validationRequired: 'You must select an option',
    passwordsMismatch: 'Passwords do not match',
    passwordFormatError: 'Password must include at least one uppercase letter, one lowercase letter, one special character, and one number',
    modalSuccessTitle: 'Account created!',
    modalSuccessMessage: 'Your account has been created. Sign in to continue.',
    modalSuccessBtn: 'Continue',
    modalErrorTitle: 'Attention',
    modalErrorBtn: 'Continue',
    modeNormalBtn: 'Standard sign up',
    modePhoneBtn: 'Sign up with phone',
    phoneRegisterSubtitle: 'Enter your phone number and we will send you a WhatsApp code to create your account.',
    phoneRegisterBtn: 'Send code',
    phoneRequiredError: 'Please enter a valid phone number.',
    phonePatternError: 'The phone number must be 10 digits long.',
    phoneCodeTitle: 'Verification',
    phoneCodeSubtitle: 'Enter the code sent to your WhatsApp',
    verifyCodeRequired: 'You must enter the complete code.',
    verifyBtn: 'Verify code',
    phoneGenericError: 'An error occurred. Please try again.',
    profileTitle: 'Complete your profile',
    profileSubtitle: 'We just need your first and last name to finish.',
    firstNameLabel: 'First name',
    firstNamePlaceholder: 'Your first name',
    lastNameLabel: 'Last name',
    lastNamePlaceholder: 'Your last name',
    emailOptionalLabel: 'Email (optional)',
    submitProfileBtn: 'Finish sign up',
    cancelBtn: 'Cancel',
    confirmCancelTitle: 'Cancel registration?',
    confirmCancelMessage: 'Are you sure you want to cancel your registration? You will lose your progress.',
    confirmCancelYesBtn: 'Yes, cancel registration',
    confirmCancelNoBtn: 'No, keep going',
  },
  recover: {
    alertTitle: 'Unable to recover password',
    alertClose: 'Close',
    recoveryError: 'Unable to send the request. Please try again.',
    pageTitle: 'Recover password',
    cardTitle: 'Recover password',
    cardSubtitle: 'Enter your email and we will send you instructions to reset your access.',
    emailLabel: 'Email address',
    emailPlaceholder: 'youremail@example.com',
    emailRequiredError: 'You must enter a valid email',
    submitBtn: 'Send instructions',
    backBtn: 'Back to sign in',
    modalSuccessTitle: 'Email sent!',
    modalSuccessMessage: 'Check your inbox and follow the instructions to reset your password.',
    modalSuccessBtn: 'Continue',
    whatsappCountdownPrefix: 'Did you not receive the email? Try sending it to WhatsApp in ',
    whatsappCountdownSuffix: ' seconds',
    whatsappLink: 'Did you not receive the email? Try sending it to WhatsApp by clicking here',
    whatsappSuccess: 'Your new password has been sent via WhatsApp.',
  },
  termsAndConditions: {
    pageTitle: 'Terms and conditions',
    title: 'TERMS AND CONDITIONS (“AGREEMENT”)',
    logoAlt: 'Parkit logo',
  },
  scanParking: {
    pageTitle: 'Scan enclosure',
    successTitle: 'Welcome!',
    successMessage: 'Thanks for using Parkit, your ticket has been scanned successfully.',
    continueButton: 'Continue',
    walletModalTitle: 'Attention',
    walletMissingTitle: 'You currently do not have a prepaid wallet.',
    walletMissingQuestion: 'Do you want to generate a new one?',
    cancelButton: 'Cancel',
    generateWalletButton: 'Yes, generate',
    entryScanButton: 'Scan entry enclosure',
    readyToScanTitle: 'Ready to scan',
    readyToScanDescription: 'Place the QR code inside the frame to scan automatically',
    scanEnclosureButton: 'Scan enclosure',
    exitScanButton: 'Scan exit enclosure',
    scanCodeTitle: 'Scan code',
    cameraLabel: 'Select camera:',
    unknownCameraLabel: 'Unknown camera',
    detailTitle: 'Details',
    accessToLabel: 'Access to:',
    entryDateLabel: 'Entry date:',
    entryTimeLabel: 'Entry time:',
    elapsedTimeLabel: 'Elapsed time',
    hoursLabel: 'Hours',
    minutesLabel: 'Minutes',
    secondsLabel: 'Seconds',
    walletButton: 'Wallet',
    enclosureTitle: 'Enclosure',
    enclosureImageAlt: 'Enclosure photo',
    balanceLabel: 'BALANCE:',
    noBalanceWarning:
      'Dear user, if you do not have balance, you will not be able to leave the enclosure.',
    addBalanceButton: 'Add balance',
    rechargeBalanceTitle: 'Reload balance',
    parkitLogoAlt: 'Parkit logo',
    emailLabel: 'Email:',
    balanceToLoadLabel: 'Amount to load:',
    goToPaymentButton: 'Go to payment',
    acceptButton: 'Accept',
    errorTitle: 'Error',
    confirmationTitle: 'Confirmation',
    noBalanceError: 'You do not have balance; you need to reload.',
    balanceRequiredError: 'You must enter the amount',
  },
  paymentFlow: {
    pageTitleCardPayment: 'Card details',
    pageTitlePaymentSummary: 'Purchase summary',
    pageTitlePaymentFinish: 'Payment confirmation',
    pageTitlePaymentError: 'Transaction failed',
    pageTitlePaymentPending: 'QR pending payment',
    pageTitleOpenpaySuccess: 'Payment confirmation',
    paymentMethodsTitle: 'Payment methods',
    timeToFinishPrefix: 'You have',
    timeToFinishSuffix: 'to complete your purchase',
    selectPaymentMethod: 'Select a payment method:',
    totalToPay: 'Total to pay',
    purchaseSummaryTitle: 'Purchase summary',
    productsLabel: 'Products',
    subtotalLabel: 'Subtotal',
    serviceChargeLabel: 'Service charge',
    discountCodePlaceholder: 'Discount code',
    appliedCodeLabel: 'Applied code:',
    applyButton: 'Apply',
    ticketCostLabel: 'Ticket cost:',
    previousCostLabel: 'Previous cost:',
    removeTicketButton: 'Remove ticket',
    emptyCartButton: 'Empty cart',
    cardThroughLabel: 'Credit / debit card through',
    mercadoPagoTitle: 'Payment through Mercado Pago',
    unsupportedCardsWarning:
      '*** American Express and CARNET cards are not accepted',
    holderNameLabel: 'Cardholder first name:',
    holderLastNameLabel: 'Cardholder last name:',
    cardNumberLabel: 'Card number:',
    cvvLabel: 'CVV:',
    cvvCvcLabel: 'CVV / CVC:',
    tipMonthYear:
      'TIP: Use two digits for the month and two digits for the year.',
    expiryMonthLabel: 'Expiration month:',
    expiryYearLabel: 'Expiration year:',
    waitingValidationNote:
      'Please wait a few seconds after completing the purchase so your bank can validate and authorize your information.',
    followInstructionsNote: 'Please follow the instructions.',
    changePaymentMethodButton: 'Change payment method',
    buyNowButton: 'Buy now',
    cashAccreditationNote:
      'Any cash payment method will be reflected in less than 1 hour.',
    paymentDueNote:
      'Please note that you only have a couple of days to complete the payment. After that period, the ticket will be released and the barcode will no longer be valid.',
    purchaseDetailTitle: 'Purchase details',
    venueLabel: 'Venue:',
    eventLabel: 'Event:',
    dateLabel: 'Date:',
    descriptionLabel: 'Description:',
    selectedZoneLabel: 'Selected zone:',
    goToPaymentButton: 'Go to payment',
    cancelButton: 'Cancel',
    continueButton: 'Continue',
    sendButton: 'Send',
    acceptButton: 'Accept',
    exitButton: 'Exit',
    payButton: 'Pay',
    closeButton: 'Close',
    yesAcceptButton: 'Yes, accept',
    noButton: 'No',
    confirmationTitle: 'Confirmation',
    oopsTitle: 'Oops!',
    errorTitle: 'Error',
    helloPrefix: 'Hello',
    referenceNumberLabel: 'This is your reference number:',
    orderIdLabel: 'This is your order ID:',
    brandTagline: 'More satisfaction, better experiences!',
    paymentCouldNotBeCompleted: 'The payment could not be completed,',
    tryAgainOrContactBank:
      'We suggest trying again or contacting your bank.',
    mercadoPagoExtraChargePrefix:
      'By selecting Mercado Pago as your payment method, an extra charge of',
    mercadoPagoExtraChargeSuffix: 'pesos will be added.',
    agreeQuestion: 'Do you agree?',
    ticketPurchasedSuccess: 'Ticket purchased successfully!',
    amountCoveredPrefix: 'The amount of',
    amountCoveredSuffix:
      'has been successfully charged. Thank you for your purchase.',
    continueToEmailPrefix: 'Click continue to send to your email',
    continueToEmailCodeSuffix: 'your code.',
    continueToEmailQrSuffix: 'your QR code.',
    mercadoPagoPurchaseMessage:
      'Thank you for your purchase. The ticket was acquired through Mercado Pago.',
    paymentOccurredErrorTitle: 'An error has occurred!',
    paymentErrorTitle: 'The payment could not be completed!',
    paymentErrorReason:
      'because we could not connect to your bank, please try again.',
    contactBankSuggestion:
      'If you believe this is an error, we suggest contacting your bank.',
    pendingPaymentTitle: 'Ticket awaiting payment!',
    pendingInstructionsPrefix: "Click 'Send' to email",
    pendingInstructionsSuffix:
      'the link with the details needed to complete the payment.',
    pendingWaitMessage:
      'If you have already completed the payment, please wait about one hour for it to be reflected in the system.',
    openpaySuccessTitle: 'Successful payment',
    openpaySuccessMessage:
      'Dear user, your payment was completed successfully. Thank you for your purchase.',
    openpayReferenceNumberLabel: 'Reference number:',
    openpayErrorTitle: 'Payment error',
    openpayErrorMessage:
      'Sorry, an error occurred while processing your payment. Please contact your bank.',
    genericValidationError:
      'An error occurred. Please verify the information entered.',
    holderNameRequired: 'Cardholder first name is required.',
    holderLastNameRequired: 'Cardholder last name is required.',
    cardNumberRequired: 'Card number is required.',
    cvvRequired: 'CVV is required.',
    cvvPattern: 'Enter the CVV code using 3 or 4 digits',
    monthRequired: 'Month is required.',
    monthPattern: 'Enter a number between 01 and 12',
    yearExpired: 'The entered year has already passed.',
    yearRequired: 'Year is required.',
    yearPattern: 'Enter the year using two digits',
    discountCodeValidMessage: 'The code you entered is valid.',
    timeLimitExpiredMessage:
      'The time limit gives all users the opportunity to get tickets.',
    cardExpiredReason: 'because your card has already expired',
    declinedInvalidMerchantReason:
      'because the transaction was declined because it was invalid or not enabled for the merchant.',
    declinedCardAccountNotFoundReason:
      'because the transaction was declined because that credit card account does not exist.',
    declinedIssuerNotFoundReason:
      'because no issuer was found for this card number.',
    declinedInsufficientFundsReason:
      'because the cardholder account does not have sufficient funds to cover the amount of the transaction. Later attempts may succeed.',
    contactBankReason:
      'if you believe this is an error, we suggest contacting your bank',
    ticketPurchaseDescription: 'Ticket purchase',
    ticketForEventPrefix: 'Ticket for event:',
    eventCanceledSuccess: 'Event canceled successfully!',
  },
  userPaySubscribe: {
    pageTitle: 'Recharge summary',
    subscriberAmountTitle: 'Subscriber - Amount to pay:',
    selectPaymentMethod: 'Select a payment method:',
    helloPrefix: 'Hello',
    paymentCouldNotBeCompleted: 'The payment could not be completed,',
    brandTagline: 'More satisfaction, better experiences!',
    acceptButton: 'Accept',
    subscriberPurchasedSuccess: 'Subscriber purchased successfully!',
    amountCoveredPrefix: 'The amount of',
    amountCoveredSuffix: 'has been successfully charged. Thank you for your purchase.',
    referenceNumberLabel: 'This is your reference number:',
    continueButton: 'Continue',
    errorTitle: 'Error',
    contactBankSuggestion: 'if you believe this is an error, we suggest contacting your bank',
    cardExpiredReason: 'because your card has already expired',
  },
  vehicles: {
    pageTitle: 'My vehicles',
    title: 'My vehicles',
    subtitle: 'Manage the vehicles you use to enter the parking facility.',
    addVehicle: 'Add vehicle',
    registeredVehiclesTitle: 'Registered vehicles',
    noRegisteredVehiclesTitle: 'You have no registered vehicles yet',
    noRegisteredVehiclesMessage: 'Add your first vehicle to prepare its parking access details.',
    addFirstVehicle: 'Add my first vehicle',
    registrationEyebrow: 'New vehicle',
    registrationTitle: 'Complete your vehicle details',
    registrationHelp: 'Select the make and model that match your vehicle.',
    edit: 'Edit',
    editVehicle: 'Edit vehicle',
    editVehicleEyebrow: 'Edit vehicle',
    editVehicleTitle: 'Update your vehicle details',
    editVehicleHelp: 'Change the information you need and save your changes.',
    country: 'Country',
    state: 'State',
    brand: 'Make',
    model: 'Model',
    color: 'Color',
    licensePlate: 'License plate',
    selectState: 'Select a state',
    selectBrand: 'Select a make',
    selectModel: 'Select a model',
    selectColor: 'Select a color',
    loadingCatalog: 'Loading makes...',
    licensePlatePlaceholder: 'E.g. ABC-123-A',
    saveVehicle: 'Save vehicle',
    cancel: 'Cancel',
    close: 'Close',
    catalogError: 'Makes and models could not be loaded.',
    retry: 'Try again',
    savingVehicle: 'Saving your vehicle...',
    updatingVehicle: 'Updating your vehicle...',
    updateVehicle: 'Save changes',
    registrationError: 'Your vehicle could not be saved. Please try again.',
  },
  userTickets: {
    pageTitle: 'My Events',
    loadingText: 'Loading Tickets',
    loadingSpinnerSr: 'Loading...',
    sectionTitle: 'My Tickets',
    filterAll: 'All',
    filterEvent: 'Event',
    filterBus: 'Bus',
    searchPlaceholder: 'Search by event, enclosure or date…',
    statusAll: 'All',
    statusLabel: 'STATUS:',
    statusActive: 'Active',
    statusBurned: 'Used',
    subfilterAll: 'All',
    subfilterIda: 'Outbound',
    subfilterVuelta: 'Return',
    legendIda: 'OUTBOUND TICKET',
    legendVuelta: 'RETURN TICKET',
    legendEvent: 'PARKING TICKET',
    travelCodeLabel: 'TRAVEL CODE:',
    legendIdaShort: 'Outbound',
    legendVueltaShort: 'Return',
    legendParkingShort: 'Parking',
    ticketCapBus: 'BUS TICKET',
    ticketCapEvent: 'EVENT TICKET',
    viewQr: 'View QR',
    ticketTypeBusPrefix: 'BUS',
    ticketTypeEvent: 'PARKING ACCESS',
    eventEyebrow: 'EVENT:',
    purchasedAtLabel: 'Ticket purchased at venue:',
    labelDate: 'Date',
    labelBusSchedule: 'Bus Schedule',
    labelZone: 'Zone',
    labelHora: 'Time',
    labelHorarioIda: 'Outbound Schedule',
    labelHorarioRegreso: 'Return Schedule',
    labelDescription: 'Description',
    validTrip: 'This ticket is valid for the trip:',
    ticketUsed: 'This ticket has already been used',
    usedHourLabel: 'Time:',
    usedDateLabel: 'Date:',
    usedByLabel: 'By:',
    useTicketBtn: 'Use ticket',
    statusBurnedBadge: 'Used',
    statusActiveBadge: 'Active',
    qrValid: 'Valid QR',
    qrExpired: 'Expired QR',
    qrPending: 'Awaiting payment confirmation',
    ticketTypeBusModal: 'BUS TICKET',
    ticketTypeEventModal: 'PARKING TICKET',
    closeBtn: 'Close',
    downloadBtn: 'Download PNG',
    pendingNote: 'Once payment is confirmed you can download your QR',
    emptyTitle: 'You have no tickets yet',
    emptyDesc1: 'When you purchase a ticket it will appear here.',
    emptyDesc2: 'Browse available events and reserve your spot.',
    emptyStep1: 'Choose your city',
    emptyStep2: 'Select venue',
    emptyStep3: 'Buy your ticket',
    exploreBtn: 'Browse events',
    backBtn: 'Go back',
    alertTitle: 'Notice',
    alertMessage: 'You have no tickets for this enclosure yet',
    cancelBtn: 'Cancel',
    confirmTitle: 'Confirmation',
    confirmMessagePrefix: 'Are you sure you want to use your ticket for:',
    acceptBtn: 'Accept',
    downloadDisclaimer: 'Digital ticket · Do not share this QR code',
    downloadZoneLabel: 'Zone:',
  },
} as const;
